import { Grid } from "@mui/material";
import { getSavingsTypeLabel } from "common/functions";
import FieldDisplay from "components/FieldDisplay";
import * as fields from "pages/clientPortfolio/personalClient/personalClientAccounts/personalSavingsFieldDefinitions";
import { PersonalSavings } from "types";
import AccountDisplayTemplate from "pages/clientPortfolio/personalClient/personalClientAccounts/components/AccountDisplayTemplate";

export type Props = {
  account: PersonalSavings;
  onEditClick(): void;
  onDeleteClick(): void;
  onAccountHistoryClick(): void;
  isReadOnlyView: boolean;
};

function PersonalSavingsDisplay({
  account,
  onEditClick,
  onDeleteClick,
  onAccountHistoryClick,
  isReadOnlyView,
}: Props) {
  const commonProps = {
    state: account,
  };

  return (
    <AccountDisplayTemplate
      id={`PERSONAL_SAVINGS_${account.accountId}_header`}
      onEditClick={onEditClick}
      onDeleteClick={onDeleteClick}
      onAccountHistoryClick={onAccountHistoryClick}
      accountType="Savings"
      accountNumber={account.accountNumber || ""}
      type={getSavingsTypeLabel(account.type ?? "")}
      balance={account.balance || 0}
      isReadOnlyView={isReadOnlyView}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <FieldDisplay<PersonalSavings>
            field={fields.personalSavingsAccounNumber}
            {...commonProps}
          />
          <FieldDisplay<PersonalSavings>
            field={fields.personalSavingsBalance}
            {...commonProps}
          />
          <FieldDisplay<PersonalSavings>
            field={fields.personalSavingsType}
            {...commonProps}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FieldDisplay<PersonalSavings>
            field={fields.personalSavingsOpenDate}
            {...commonProps}
          />
          <FieldDisplay<PersonalSavings>
            field={fields.personalSavingsCloseDate}
            {...commonProps}
          />
        </Grid>
      </Grid>
    </AccountDisplayTemplate>
  );
}

export default PersonalSavingsDisplay;
